import { render, staticRenderFns } from "./NavigationSubItem.vue?vue&type=template&id=582297d9"
import script from "./NavigationSubItem.vue?vue&type=script&lang=js"
export * from "./NavigationSubItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationSubItem.vue?vue&type=style&index=0&id=582297d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports